var _ = require('underscore');
var $ = require('jquery');
var surveyLanguageCollection = require('./surveyLanguageCollection');
var TorsoService = require('backbone-torso/modules/ServiceCell');

/**
 * The surveyLanguageService sets up managing the survey language to use for display.
 *
 * @class SurveyLanguageService
 * @constructor
 */
module.exports = new (TorsoService.extend({
  /**
   * @property _defaultLanguageKey {String} the language key to use if the language of the browser couldn't be calculated.
   * @private
   */
  _defaultLanguageKey: 'en',

  /**
   * @method initialize
   * @override
   */
  initialize: function() {
    this.getLanguage = _.memoize(this.getLanguage);
  },

  /**
   * Returns a promise that resolves as the Model object corresponding to the browser's language
   *   or the default language if the browser language could not be found,
   *   or null if the model isn't found in the collection.
   *
   * @method getBrowserLanguage
   * @return {$.Deferred} that resolves as the language model corresponding to the browser language model.
   */
  getBrowserLanguage: function() {
    return this.getLanguage(this._getLanguageKeyForCurrentBrowser());
  },

  /**
   * Returns a promise that resolves as the Model object corresponding to the default language,
   *   or null if the model isn't found in the collection.
   *
   * @method getDefaultLanguage
   * @returns {$.Deferred} that resolves as the language model corresponding to the default language ('en') model.
   */
  getDefaultLanguage: function() {
    return this.getLanguage(this._defaultLanguageKey);
  },

  /**
   * Returns a promise that resolves as the language
   * @method getLanguage
   * @param languageKey {String} the key to use to retrieve the language from the collection.
   * @returns {$.Deferred} that resolves as the language with the given key after the collection of languages has completed fetching.
   */
  getLanguage: function(languageKey) {
    return surveyLanguageCollection.fetchOnce()
      .then(function() {
        return surveyLanguageCollection.findWhere({languageKey: languageKey});
      }, function() {
        return null;
      });
  },

  /**
   * Use the jQuery i18n plugin to determine the language being displayed in the browser.
   *
   * @method _getLanguageKeyForCurrentBrowser
   * @private
   * @returns {string} the language key for this browser or the default language key if the browser key could not be found.
   */
  _getLanguageKeyForCurrentBrowser: function() {
    //note that for Chrome this is the language that Chrome was installed as, not user settings
    var locale = $.i18n.browserLang();

    // browserLang() could return 'en_US' or 'en', we just want the key part ('en').
    return locale ? locale.substring(0, 2) : this._defaultLanguageKey;
  }
}))();
